export default __webpack_public_path__ + "static/media/shutterstock_1091337098.413a8cd0.png";